import Swiper from "../../assets/.npm/node_modules/swiper";
import Navigation from "../../assets/.npm/node_modules/swiper/modules/navigation.min.mjs";

export default () => {
  let swiperBanner = new Swiper(".slider-banner", {
    modules: [Navigation],
    slidesPerView: 1, 
    loop: true,
    navigation: {
      nextEl: ".banner-next",
      prevEl: ".banner-prev",
    },
  });
}
  
